import { useQuery } from '@apollo/client';

import { QUERY } from '../gql-operations';

const toNonNegativeNumber = (value, fallback = 0) => {
    const numericValue = Number(value);
    if (!Number.isFinite(numericValue)) {
        return Number(fallback) || 0;
    }
    return Math.max(0, numericValue);
};

const clampPercent = (value) => Math.max(0, Math.min(100, Number(value) || 0));

const NOOP_REFETCH = async () => null;

export const useCredits = ({
    includeUsagePercent = false,
    skip = false,
    fallbackCredits = 0
} = {}) => {
    const creditsQuery = useQuery(QUERY.GET_CREDITS, {
        skip,
        fetchPolicy: 'cache-and-network'
    });

    const usageQuery = useQuery(QUERY.GET_CREDITS_USAGE_PERCENT, {
        skip: skip || !includeUsagePercent,
        fetchPolicy: 'cache-and-network'
    });

    const credits =
        creditsQuery.data?.getCredits != null
            ? toNonNegativeNumber(creditsQuery.data.getCredits)
            : toNonNegativeNumber(fallbackCredits);

    const usagePercent =
        includeUsagePercent && usageQuery.data?.getCreditsUsagePercent != null
            ? clampPercent(usageQuery.data.getCreditsUsagePercent)
            : 0;

    return {
        credits,
        hasCredits: credits > 0,
        creditsLoading: creditsQuery.loading,
        refetchCredits: creditsQuery.refetch,
        usagePercent,
        approxUsagePercent: Math.round(usagePercent),
        usageLoading: includeUsagePercent ? usageQuery.loading : false,
        refetchUsagePercent: includeUsagePercent ? usageQuery.refetch : NOOP_REFETCH
    };
};

export default useCredits;
